import {StrictMode} from 'react'
import {createBrowserRouter, RouterProvider} from 'react-router'
import {QueryClientProvider} from '@tanstack/react-query'
import {createQueryClient} from './state/query-client.js'
import {AuthProvider} from './auth/auth-provider.jsx'
import {routes} from './routes.jsx'

const queryClient = createQueryClient()
const router = createBrowserRouter(routes)

export function App() {
    return (
        <StrictMode>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <RouterProvider router={router}/>
                </AuthProvider>
            </QueryClientProvider>
        </StrictMode>
    )
}
